/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
	| T
	| {
			[P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
	  };
import type * as Types from '../../../../../gql/types-mutations';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetCognitoUserPreferencesQueryVariables = Exact<{
	[key: string]: never;
}>;

export type GetCognitoUserPreferencesQuery = {
	getCognitoUserPreferences: {
		id: string;
		newsletter_opt_in: boolean | null;
		saved_tags: Array<{
			id: string;
			name: string;
			type: Types.SavedTagType;
		} | null> | null;
	} | null;
};

export const GetCognitoUserPreferencesDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'getCognitoUserPreferences' },
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'getCognitoUserPreferences' },
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'newsletter_opt_in' },
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'saved_tags' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'name' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'type' } },
										],
									},
								},
							],
						},
					},
				],
			},
		},
	],
} as unknown as DocumentNode<
	GetCognitoUserPreferencesQuery,
	GetCognitoUserPreferencesQueryVariables
>;
